"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UICardHeader;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _UICardSection = _interopRequireDefault(require("../card/UICardSection"));

var _UIAccordionItem = _interopRequireDefault(require("../accordion/UIAccordionItem"));

var _UIFlex = _interopRequireDefault(require("../layout/UIFlex"));

var _AbstractTextElement = _interopRequireDefault(require("../elements/AbstractTextElement"));

var _omit = _interopRequireDefault(require("../utils/underscore/omit"));

var headingForSize = {
  'extra-small': 'span',
  small: 'h5',
  medium: 'h4',
  large: 'h2',
  'extra-large': 'h1'
};

function UICardHeader(props) {
  var className = props.className,
      expanded = props.expanded,
      onExpandedChange = props.onExpandedChange,
      title = props.title,
      titleSize = props.titleSize,
      toolbar = props.toolbar,
      other = (0, _objectWithoutProperties2.default)(props, ["className", "expanded", "onExpandedChange", "title", "titleSize", "toolbar"]);
  var isExpander = typeof onExpandedChange === 'function';
  var renderedTitle = isExpander ? _react.default.createElement(_UIAccordionItem.default, {
    className: "private-card__title",
    onOpenChange: onExpandedChange,
    open: expanded,
    title: title,
    size: titleSize
  }) : _react.default.createElement(_AbstractTextElement.default, {
    className: "private-card__title",
    tagName: headingForSize[titleSize]
  }, title);
  return _react.default.createElement(_UICardSection.default, (0, _extends2.default)({
    className: (0, _classnames.default)('private-card__header', className, {
      'private-card__header--with-toolbar': !!toolbar,
      'private-card__header--expandable': isExpander === true
    })
  }, other), _react.default.createElement(_UIFlex.default, {
    align: "start",
    justify: "between"
  }, renderedTitle, toolbar && expanded ? _react.default.createElement("div", {
    className: "private-card__toolbar"
  }, toolbar) : null));
}

UICardHeader.propTypes = (0, _extends2.default)({}, (0, _omit.default)(_UICardSection.default.propTypes, ['children']), {
  expanded: _propTypes.default.bool.isRequired,
  onExpandedChange: _propTypes.default.func,
  title: _propTypes.default.node,
  titleSize: _propTypes.default.oneOf(['extra-small', 'small', 'medium', 'large', 'extra-large']),
  toolbar: _propTypes.default.node
});
UICardHeader.defaultProps = {
  expanded: true,
  titleSize: 'medium'
};
UICardHeader.displayName = 'UICardHeader';
module.exports = exports.default;